/* eslint-disable */
  /* tslint:disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

/**
 * Defines the shape of a Modbus device fields. Used to configure Modbus devices on the BEE
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "modbus_device_fields".
 */
export type ModbusDeviceFields = {
  name?: string;
  format?: "float" | "int" | "ascii" | "uint";
  factor?: number;
  unit?: string;
  access?: string;
  address?: string;
  length?: number;
  [k: string]: any;
}[];
/**
 * Defines the shape of a Mastertherm device fields. Used to configure Mastertherm devices on the BEE
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "mastertherm_device_fields".
 */
export type MasterthermDeviceFields = {
  name?: string;
  format?: "float" | "int" | "ascii";
  factor?: number;
  unit?: string;
  access?: string;
  address?: string;
  length?: number;
  [k: string]: any;
}[];
/**
 * The label for the circuit
 */
export type CircuitLabel = string;
/**
 * The circuit label for clamp 1
 */
export type CircuitLabelForClamp1 = string;
/**
 * The circuit label for clamp 2
 */
export type CircuitLabelForClamp2 = string;
/**
 * The circuit label for clamp 3
 */
export type CircuitLabelForClamp3 = string;
/**
 * A list of non-metered circuits
 */
export type NonMeteredCircuits = string;
/**
 * The position of the dip switch
 */
export type DipSwitchPosition = string | number;
/**
 * The amperage of the meter
 */
export type MeterAmperage = string | number;
/**
 * Specifies a unique identifier for multiple devices of the same type within a home
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "sensor_id".
 */
export type DeviceSensorId = string;
/**
 * Specifies the address of a device
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "address".
 */
export type DeviceAddress = string;
/**
 * Specifies the channel a device will communicate on
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "channel".
 */
export type DeviceChannel = string;
/**
 * Determines if the rule being setup is used as the primary zone temperature sensor
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "primary_zone_temperature_sensor".
 */
export type PrimaryZoneTemperatureSensor = string;
/**
 * The circuit type for clamp 1
 */
export type CircuitTypeForClamp1 = string;
/**
 * The circuit type for clamp 2
 */
export type CircuitTypeForClamp2 = string;
/**
 * The circuit type for clamp 3
 */
export type CircuitTypeForClamp3 = string;
/**
 * The circuit type for clamp 4
 */
export type CircuitTypeForClamp4 = string;
/**
 * The circuit type for clamp 5
 */
export type CircuitTypeForClamp5 = string;
/**
 * The circuit type for clamp 6
 */
export type CircuitTypeForClamp6 = string;

export interface BEEConfiguration {
  metadata?: BEEMetadata;
  /**
   * Defines the version of the current schema config. Used by the BEE to determine if it has changed
   */
  schema_version: "2.0.0" | "2.3.0";
  /**
   * Defines the version of the current rules config. Used by the BEE to determine if it has changed
   */
  rules_version?: string;
  /**
   * Defines the version of the current schedules config. Used by the BEE to determine if it has changed
   */
  schedules_version?: string;
  /**
   * Defines the version of the current devices config. Used by the BEE to determine if it has changed
   */
  devices_version?: string;
  /**
   * Defines the version of the user heating schedules config. Used by the BEE to determine if it has changed
   */
  heating_schedules_version?: string;
  /**
   * Defines the version of the user hot water schedules config. Used by the BEE to determine if it has changed
   */
  hot_water_schedules_version?: string;
  /**
   * @deprecated Defines the version of the user heating zones config. Used by the BEE to determine if it has changed
   */
  heating_zones_version?: string;
  device_config: DeviceConfig;
  /**
   * A list of peripheral devices that are supported by the BEE and contain configuration for rules to understand how to retrieve data from a specific device
   */
  devices: (MBusDevice | RelayDevice | ModbusDevice | MasterthermDevice)[];
  /**
   * A list of schedules to be run by the BEE for specific rules. The name property must refer back to a rule name
   */
  schedules: Schedule[];
  /**
   * A list of rules that should be run by the BEE to monitor or perform control
   */
  rules: Rule[];
  /**
   * A list of heating schedules to be run by the BEE. A maximum of 7 days can be defined here
   */
  heating_schedules: {
    monday?: HeatingSchedule[];
    tuesday?: HeatingSchedule[];
    wednesday?: HeatingSchedule[];
    thursday?: HeatingSchedule[];
    friday?: HeatingSchedule[];
    saturday?: HeatingSchedule[];
    sunday?: HeatingSchedule[];
  };
  /**
   * @deprecated A list of heating zones available to the BEE
   */
  heating_zones?: HeatingZone[];
  hot_water_schedules?: HotWaterSchedules;
  /**
   * A list of settings for the BEE
   */
  settings?: {
    /**
     * The intervals in which the state events are run at.
     */
    state_tx_interval_mins?: number;
    [k: string]: any;
  };
}
/**
 * Metadata information for a BEE
 */
export interface BEEMetadata {
  [k: string]: any;
}
/**
 * Defines configuration to be used by the BEE for runtime operations
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "device_config".
 */
export interface DeviceConfig {
  /**
   * Specifies the location the device is in for timezone information
   */
  location: "Europe/London";
  heating?: DeviceConfigHeating;
  hot_water_temperature?: DeviceConfigHotWaterTemperature;
  temperature?: DeviceConfigTemperature;
}
/**
 * The shape of the heating object for the device config
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "device_config_heating".
 */
export interface DeviceConfigHeating {
  temperature: DeviceConfigHeatingTemperature;
  [k: string]: any;
}
/**
 * The shape of the temperature object for the device config heating configuration
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "device_config_heating_temperature".
 */
export interface DeviceConfigHeatingTemperature {
  upper: number;
  lower: number;
}
/**
 * The shape of the temperature object for the device config hot water configuration
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "device_config_hot_water_temperature".
 */
export interface DeviceConfigHotWaterTemperature {
  /**
   * The on temperature
   */
  on: number;
  /**
   * The off temperature
   */
  off: number;
}
/**
 * @deprecated The shape of the temperature object for the device config
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "device_config_temperature".
 */
export interface DeviceConfigTemperature {
  upper: number;
  lower: number;
}
/**
 * Defines the shape of a MBus device. Used to configure MBus devices on the BEE
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "mbus_device".
 */
export interface MBusDevice {
  name: string;
  protocol: "MBus";
}
/**
 * Defines the shape of a relay device. Used to configure relay devices on the BEE
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "relay_device".
 */
export interface RelayDevice {
  name: string;
  protocol: "gpio";
}
/**
 * Defines the shape of a Modbus device. Used to configure Modbus devices on the BEE
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "modbus_device".
 */
export interface ModbusDevice {
  name: string;
  protocol: "ModbusRTU" | "ModbusTCP" | "internal";
  fields: ModbusDeviceFields;
}
/**
 * Defines the shape of a Mastertherm device. Used to configure Mastertherm devices on the BEE
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "mastertherm_device".
 */
export interface MasterthermDevice {
  name: string;
  protocol: "ModbusTCP";
  fields: MasterthermDeviceFields;
}
/**
 * Defines the shape of a schedule. Used to run rules on the BEE. The name of a schedule should refer back to the name of a rule
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "schedule".
 */
export interface Schedule {
  name: string;
  schedule:
    | "once"
    | "second"
    | "second_2"
    | "second_5"
    | "second_15"
    | "second_30"
    | "minute"
    | "minute_5"
    | "minute_10"
    | "minute_15"
    | "minute_30"
    | "hour"
    | "disabled";
}
/**
 * Defines the shape of a rule. A rule is made up of queries, conditions, inputs, name, description and metadata
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "rule".
 */
export interface Rule {
  name: string;
  description: string;
  metadata?: DeviceRulesMetadata;
  inputs: DeviceRulesInputs;
  queries:
    | []
    | [
        {
          name: string;
          device_name?: string;
          type: "system_state" | "system_zone_state" | "system_device_config_state" | "device";
          attributes: [] | [string, ...any[]];
        },
        ...any[]
      ];
  conditions: {
    type: "run_actions" | "if" | "and" | "or" | "if_end";
    condition?: {
      [k: string]: any;
    };
    actions: {
      type:
        | "mqtt_publish"
        | "set_persisted_system_state"
        | "set_non_persisted_system_state"
        | "set_persisted_zone_state"
        | "set_non_persisted_zone_state"
        | "set_zone_wrf06_state"
        | "set_input"
        | "set_relay"
        | "set_relay_with_hysteresis"
        | "set_device"
        | "debug"
        | "schedule"
        | "run_rule"
        | "run_heating_schedule"
        | "run_hot_water_schedule"
        | "cancel_hot_water_override"
        | "cancel_device_off";
      params: {
        [k: string]: any;
      };
    }[];
  }[];
}
/**
 * The shape of the metadata object for device rules configuration
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "rule_metadata".
 */
export interface DeviceRulesMetadata {
  heating_system?: HeatingSystem;
  circuit_label?: CircuitLabel;
  clamp_1_circuit_label?: CircuitLabelForClamp1;
  clamp_2_circuit_label?: CircuitLabelForClamp2;
  clamp_3_circuit_label?: CircuitLabelForClamp3;
  non_metered_circuits?: NonMeteredCircuits;
  install_location?: PhysicalLocationID;
  dip_switch_position?: DipSwitchPosition;
  meter_amperage?: MeterAmperage;
  category?: RuleCategory;
  heat_flow_meter_circuit?: HeatFlowMeterCircuit;
  action_type?: RuleActionType;
  variant?: RuleVariant;
  heat_pump_heating_control?: HeatPumpHeatingControl;
}
/**
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "rule_inputs".
 */
export interface DeviceRulesInputs {
  device_type?: DeviceType;
  zone_id?: HeatingZoneID;
  sensor_id?: DeviceSensorId;
  address?: DeviceAddress;
  channel?: DeviceChannel | DeviceChannelForTCPConnections;
  primary_zone_temperature_sensor?: PrimaryZoneTemperatureSensor;
  hot_water_source_type?: HotWaterSourceType;
  metadata?: DeviceRulesInputMetadata;
  [k: string]: any;
}
/**
 * Describes the shape of a channel for a TCP connection
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "channel_tcp".
 */
export interface DeviceChannelForTCPConnections {
  address?: string;
  port?: number;
  [k: string]: any;
}
/**
 * The shape of the metadata object for device rules input configuration
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "rule_input_metadata".
 */
export interface DeviceRulesInputMetadata {
  circuit_type?: CircuitType;
  clamp_1_circuit_type?: CircuitTypeForClamp1;
  clamp_2_circuit_type?: CircuitTypeForClamp2;
  clamp_3_circuit_type?: CircuitTypeForClamp3;
  clamp_4_circuit_type?: CircuitTypeForClamp4;
  clamp_5_circuit_type?: CircuitTypeForClamp5;
  clamp_6_circuit_type?: CircuitTypeForClamp6;
}
/**
 * Defines the shape of a heating schedule. A heating schedule is made up of 7 days (Monday - Sunday) with a maximum of 6 setpoints for each day
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "heating_schedule".
 */
export interface HeatingSchedule {
  zone_id: HeatingZoneID;
  setpoints: HeatingScheduleSetpoint[];
  [k: string]: any;
}
/**
 * Defines the shape of a setpoint for a heating schedule
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "heating_schedule_setpoint".
 */
export interface HeatingScheduleSetpoint {
  time: string;
  temperature: number;
  /**
   * The time the user has set the schedule for
   */
  user_time?: string;
  type?: "start" | "end";
}
/**
 * Defines heating zones available to a BEE
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "heating_zone".
 */
export interface HeatingZone {
  zone_id: HeatingZoneID;
  /**
   * Specifies the description of the heating zone
   */
  description?: string;
}
/**
 * A hot water schedule for each day of the week and times to start heating water and stop heating water
 */
export interface HotWaterSchedules {
  monday?: HotWaterSchedule[];
  tuesday?: HotWaterSchedule[];
  wednesday?: HotWaterSchedule[];
  thursday?: HotWaterSchedule[];
  friday?: HotWaterSchedule[];
  saturday?: HotWaterSchedule[];
  sunday?: HotWaterSchedule[];
}
/**
 * Defines the shape of a hot water schedule. A hot water schedule is made up of 7 days (Monday - Sunday) with a maximum of 6 setpoints for each day
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "hot_water_schedule".
 */
export interface HotWaterSchedule {
  zone_id: HeatingZoneID;
  setpoints: HotWaterScheduleSetpoint[];
}
/**
 * Defines the shape of a setpoint for a hot water schedule
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "hot_water_schedule_setpoint".
 */
export interface HotWaterScheduleSetpoint {
  time: string;
  hot_water_active: 0 | 1;
  /**
   * The time the user set the schedule for
   */
  user_time?: string;
}

/**
 * The shape of the heating system object for device rules configuration metadata
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "rule_metadata_heating_system".
 */
export enum HeatingSystem {
  NOT_CONTROLLED_BY_IES = "Heating not controlled by the IES",
  COMBI = "Combi boiler",
  HOTWATER_CYLINDER = "Boiler with hot water cylinder",
  MASTERTHERM = "MasterTherm heat pump"
}
/**
 * Location IDs which excludes whole_home
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "physical_location_id".
 */
export enum PhysicalLocationID {
  LIVING_ROOM = "living_room",
  KITCHEN = "kitchen",
  GROUND_FLOOR = "ground_floor",
  FIRST_FLOOR = "first_floor",
  SECOND_FLOOR = "second_floor",
  THIRD_FLOOR = "third_floor",
  BEDROOM_1 = "bedroom_1",
  BEDROOM_2 = "bedroom_2",
  BATHROOM = "bathroom"
}
/**
 * Categorises rules into functional groups
 */
export enum RuleCategory {
  TEMPERATURE = "temperature",
  THERMOSTAT = "thermostat",
  DIAL = "dial",
  ELECTRICITY = "electricity",
  HEATING = "heating",
  HOT_WATER = "hot_water",
  HEAT_FLOW = "heat_flow"
}
/**
 * The circuit the heat flow meter
 */
export enum HeatFlowMeterCircuit {
  HEATING = "heating",
  HOT_WATER = "hot_water"
}
/**
 * The action type that will be performed
 */
export enum RuleActionType {
  CONTROL = "control",
  MONITORING = "monitoring"
}
/**
 * The variation of the rule to use
 */
export enum RuleVariant {
  IMMERSION_HEATER = "immersion_heater",
  COMBI_BOILER = "combi_boiler",
  SYSTEM_BOILER = "system_boiler",
  VAILANT = "vailant"
}
/**
 * The heating system to control within the heat pump
 */
export enum HeatPumpHeatingControl {
  HC1 = "HC1",
  HC2 = "HC2"
}
/**
 * Defines the supported device types, which correlates with device drivers
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "device_type".
 */
export enum DeviceType {
  IEM2055 = "iem2055",
  IEM2155 = "iem2155",
  IEM3100 = "iem3100",
  SCHNEIDER_IEM3455 = "schneider_iem3455",
  EASTRON_SDM630MCT_MV = "eastron_sdm630mct_mv",
  EASTRON_SDM630MCT_4L = "eastron_sdm630mct_4L",
  EASTRON_SDM630MCT_MID = "eastron_sdm630mct_mid",
  SHARKY = "sharky",
  WRF04 = "wrf04",
  WRF06 = "wrf06",
  RELAY = "relay",
  MASTERTHERM = "mastertherm",
  REGIN = "regin",
  NOVOS3 = "novos3",
  NTCTF25 = "ntctf25",
  ade7816 = "ade7816",
  ISOIL_IFXM4E3 = "isoil_ifxm4e3"
}
/**
 * Specifies the name of the heating zone
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "zone_id".
 */
export enum HeatingZoneID {
  WHOLE_HOME = "whole_home",
  LIVING_ROOM = "living_room",
  KITCHEN = "kitchen",
  GROUND_FLOOR = "ground_floor",
  FIRST_FLOOR = "first_floor",
  SECOND_FLOOR = "second_floor",
  THIRD_FLOOR = "third_floor",
  BEDROOM_1 = "bedroom_1",
  BEDROOM_2 = "bedroom_2",
  HOT_WATER = "hot_water",
  BATHROOM = "bathroom"
}
/**
 * The different types of hot water sources
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "hot_water_source_type".
 */
export enum HotWaterSourceType {
  PRIMARY = "primary",
  SECONDARY = "secondary"
}
/**
 * The shape of the circuit type object for device rules configuration metadata
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "rule_metadata_circuit_type".
 */
export enum CircuitType {
  REGULATED = "Regulated",
  UNREGULATED = "Unregulated",
  WHOLE_HOME = "Whole home",
  MAIN_INCOMING_SUPPLY = "Main incoming supply"
}
/**
 * Definitive list of hot water sources
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "hot_water_source".
 */
export enum HotWaterSource {
  SYSTEM_BOILER = "System boiler",
  HEAT_PUMP = "Heat pump",
  IMMERSION_HEATER = "Immersion heater",
  COMBI_BOILER = "Combi Boiler",
  OTHER = "Other"
}
